<template>
  <div class="f-discoverAlpfoodway">
    <b-modal id="discoverAlpfoodway"
             ref="discoverAlpfoodway"
             size="lg"
             title="Discover AlpFoodway">
      <img src="../../../../assets/poster.jpg">
      <div slot="modal-footer" class="w-100">
        <b-button class="button-style-grey float-right" @click="hideModal">Close</b-button>
        <a href="../../../../../static/img/poster.pdf" download>
          <b-button class="button-style float-left">Download the poster</b-button>
        </a>
      </div>

    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'DiscoverAlpFoodway',
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      }
    },
    methods: {
      showModal () {
        this.$refs.discoverAlpfoodway.show()
      },
      hideModal () {
        this.$refs.discoverAlpfoodway.hide()
      }
    },
    mounted () {
      document.getElementById('discoverAlpfoodway___BV_modal_header_').setAttribute('style', 'background-color: #c41c21 !important; color: white !important;')
      document.getElementById('discoverAlpfoodway___BV_modal_header_').lastChild.setAttribute('style', 'color: white !important;')
    }
  }
</script>

<style scoped>
  .button-style {
    background-color: #c41c21 !important;
    border-color: #c41c21 !important;
  }

  .button-style-grey {
    background-color: grey !important;
    border-color: grey !important;
  }

  img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/cartaAlpFoodWay/DiscoverAlpFoodway.vue